import React, { useEffect, useState } from "react";
import cl from "./Products.module.css";
import Product from "./Product/Product";
import { animateScroll as scroll } from "react-scroll";
import { getRandomNumber } from "../Home/Home";

const Products = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const [howMuch, setHowMuch] = useState(6);
  const [isShow, setIsShow] = React.useState(true);
  let featuredProducts = (p) => {
    if (props.productsData.indexOf(p) < howMuch) {
      return (
        <Product
          key={getRandomNumber(1, 10000)}
          onAdd={props.onAdd}
          productId={p.productId}
          name={p.name}
          images={p.images}
          oldPrice={p.oldPrice}
          currency={p.currency}
          discount={p.discount}
          path={p.path}
        />
      );
    }
  };

  let onShowMore = () => {
    if (howMuch < props.productsData.length - 6) {
      setHowMuch(howMuch + 6);
    } else {
      setHowMuch(howMuch + 6);
      setIsShow(!isShow);
    }
  };

  let productElements = props.productsData.map((p) => featuredProducts(p));

  return (
    <section className={cl.main}>
      <div>
        <h1 className={cl.title}>All products</h1>
      </div>
      <div className={cl.products}>{productElements}</div>
      <div className={cl.products_more}>
        {isShow && (
          <a className={cl.products_more} onClick={onShowMore}>
            Show more
          </a>
        )}
      </div>
    </section>
  );
};

export default Products;
